export interface CertificateBlock {
  note: 1 | 2;
  variant: 1 | 2;
  text: string;
}

export interface CertificateCategory {
  field: string;
  labelKey: string;
  blocks: CertificateBlock[];
}

const WORK_CERTIFICATE_DE: CertificateCategory[] = [
  {
    field: 'fachwissen',
    labelKey: 'certificateCreator.sections.expertise',
    blocks: [
      { note: 1, variant: 1, text: '(Name) verfügte über ein hervorragendes und auch in Randbereichen sehr tiefgehendes Fachwissen, welches (er/sie) in unser Unternehmen stets in höchst gewinnbringender Weise einbrachte.' },
      { note: 1, variant: 2, text: '(Name) verfügte über eine sehr große Berufserfahrung und äußerst umfassende Fachkenntnisse, die (er/sie) immer sehr sicher und gekonnt in der Praxis einsetze.' },
      { note: 2, variant: 1, text: '(Name) verfügte über umfassende und vielseitige Fachkenntnisse, die (er/sie) immer sicher und gekonnt in der Praxis einsetze.' },
      { note: 2, variant: 2, text: '(Name) verfügte über ein sehr fundiertes, gutes Fachwissen, welches (er/sie) unserem Unternehmen stets in gewinnbringender Weise zur Verfügung stellte.' },
    ],
  },
  {
    field: 'weiterbildung',
    labelKey: 'certificateCreator.sections.furtherTraining',
    blocks: [
      { note: 1, variant: 1, text: '(Er/Sie) besuchte regelmäßig und sehr erfolgreich Weiterbildungsmaßnahmen intern wie auch extern, um (seine/ihre) Stärken weiter auszubauen und (seine/ihre) hervorragenden Fachkenntnisse zu erweitern.' },
      { note: 1, variant: 2, text: '(Er/Sie) nahm regelmäßig an den unterschiedlichsten, fachbezogenen internen und externen Weiterbildungsmaßnahmen teil und bereicherte dadurch immer wieder mit neuen Impulsen die Arbeit in unserem Unternehmen.' },
      { note: 2, variant: 1, text: 'Zum Nutzen unseres Unternehmens erweiterte und aktualisierte (er/sie) immer mit gutem Erfolg (seine/ihre) umfassenden Kenntnisse durch regelmäßige Teilnahmen an Weiterbildungsmöglichkeiten.' },
      { note: 2, variant: 2, text: '(Er/Sie) nahm regelmäßig an den unterschiedlichsten, fachbezogenen internen und externen Weiterbildungsmaßnahmen erfolgreich teil.' },
    ],
  },
  {
    field: 'auffassungsgabe',
    labelKey: 'certificateCreator.sections.comprehension',
    blocks: [
      { note: 1, variant: 1, text: 'Aufgrund (seiner/ihrer) sehr guten Auffassungsgabe war (er/sie) jederzeit in der Lage, auch schwierige Situationen sofort zutreffend zu erfassen und schnell sehr gute Lösungen zu finden.' },
      { note: 1, variant: 2, text: 'Besonders hervorzuheben waren (seine/ihre) ausgesprochene schnelle Auffassungsgabe und (sein/ihr) analytisches Denkvermögen.' },
      { note: 2, variant: 1, text: 'Aufgrund (seiner/ihrer) genauen Analysefähigkeit und (seiner/ihrer) schnellen Auffassungsgabe war (er/sie) jederzeit in der Lage, auch schwierige Situationen sofort zutreffend zu erfassen und schnell gute Lösungen zu finden.' },
      { note: 2, variant: 2, text: 'Besonders hervorzuheben waren (sein/ihr) gutes analytisches Denkvermögen und (seine/ihre) rasche Auffassungsgabe.' },
    ],
  },
  {
    field: 'leistungsbereitschaft',
    labelKey: 'certificateCreator.sections.motivation',
    blocks: [
      { note: 1, variant: 1, text: '(Name) zeigte jederzeit hohe Eigeninitiative und identifizierte sich immer voll mit (seinen/ihren) Aufgaben und unserem Unternehmen. (Er/Sie) überzeugte durch (seine/ihre) sehr große Einsatzfreude.' },
      { note: 1, variant: 2, text: '(Name) war (ein/eine) äußerst (engagierter/engagierte) (Mitarbeiter/Mitarbeiterin), (der/die) besonders durch (seine/ihre) außergewöhnliche Leistungsbereitschaft und außerordentliche Einsatzbereitschaft überzeugen konnte.' },
      { note: 2, variant: 1, text: '(Name) zeigte jederzeit hohe Eigeninitiative und identifizierte sich immer voll mit (seinen/ihren) Aufgaben und unserem Unternehmen. (Er/Sie) überzeugte durch (seine/ihre) große Einsatzfreude.' },
      { note: 2, variant: 2, text: '(Name) war (ein/eine) (belastbarer/belastbare) und (verantwortungsbewusster/verantwortungsbewusste) (Mitarbeiter/Mitarbeiterin). (Er/Sie) gab mit großem Einsatz kontinuierliche Impulse zur Verbesserung unserer Dienstleistung.' },
    ],
  },
  {
    field: 'belastbarkeit',
    labelKey: 'certificateCreator.sections.resilience',
    blocks: [
      { note: 1, variant: 1, text: 'Auch in Situationen mit größtem Arbeitsaufkommen erwies (er/sie) sich immer als in höchstem Maße belastbar.' },
      { note: 1, variant: 2, text: 'Auf (seine/ihre) umsichtige und gewissenhafte Arbeitsweise war auch in herausfordernden Situationen jederzeit Verlass.' },
      { note: 2, variant: 1, text: 'Auch unter schwierigen Arbeitsbedingungen und Termindruck bewältigte (er/sie) alle Aufgaben in guter Weise.' },
      { note: 2, variant: 2, text: 'Auch in Situationen mit hohem Arbeitsaufkommen erwies (er/sie) sich immer als besonders belastbar.' },
    ],
  },
  {
    field: 'arbeitsweise',
    labelKey: 'certificateCreator.sections.workStyle',
    blocks: [
      { note: 1, variant: 1, text: '(Seine/Ihre) Aufgaben führte (er/sie) mit größter Umsicht und hohem Verantwortungsbewusstsein aus. (Er/Sie) war äußerst belastbar, sehr gewissenhaft und arbeitete stets zügig.' },
      { note: 1, variant: 2, text: '(Name) arbeitete jederzeit sehr zielstrebig, äußerst sorgfältig und mit größter Effizienz. Dabei agierte (er/sie) außerordentlich qualitäts- und verantwortungsbewusst.' },
      { note: 2, variant: 1, text: '(Name) arbeitete sehr zielstrebig, sehr sorgfältig und mit großer Effizienz. Dabei agierte (er/sie) immer qualitäts- und verantwortungsbewusst.' },
      { note: 2, variant: 2, text: '(Seine/Ihre) Arbeitsweise war sowohl hinsichtlich Kunden- als auch Zielorientierung stets in hohem Maße dienstleistungsorientiert und in jeder Hinsicht sehr gut.' },
    ],
  },
  {
    field: 'zuverlaessigkeit',
    labelKey: 'certificateCreator.sections.reliability',
    blocks: [
      { note: 1, variant: 1, text: '(Name) arbeitete immer außerordentlich zuverlässig und sehr genau.' },
      { note: 1, variant: 2, text: '(Seine/Ihre) Verlässlichkeit und Zuverlässigkeit waren jederzeit vorbildlich.' },
      { note: 2, variant: 1, text: '(Name) arbeitete stets zuverlässig und sehr genau.' },
      { note: 2, variant: 2, text: '(Name) war in hohem Maße zuverlässig und loyal.' },
    ],
  },
  {
    field: 'arbeitsergebnis',
    labelKey: 'certificateCreator.sections.workResults',
    blocks: [
      { note: 1, variant: 1, text: 'Auch für schwierige Problemstellungen fand (er/sie) sehr effektive Lösungen, die (er/sie) jederzeit erfolgreich in der Praxis umsetze und damit immer ausgezeichnete Arbeitsergebnisse erzielte.' },
      { note: 1, variant: 2, text: '(Name) überzeugte in besonderem Maße durch die jederzeit sehr gute Qualität (seiner/ihrer) Arbeitsergebnisse.' },
      { note: 2, variant: 1, text: 'Auch bei anspruchsvollen Aufgaben und unter schwierigen Bedingungen erzielte (er/sie) stets gute Ergebnisse.' },
      { note: 2, variant: 2, text: 'Für alle auftretenden Herausforderungen fand (er/sie) ausnahmslos gute Lösungen.' },
    ],
  },
  {
    field: 'zusammenfassendeBeurteilung',
    labelKey: 'certificateCreator.sections.overallAssessment',
    blocks: [
      { note: 1, variant: 1, text: 'Die Leistungen von (Namen) haben jederzeit und in jeder Hinsicht unsere vollste Anerkennung gefunden.' },
      { note: 1, variant: 2, text: '(Name) führte den (ihm/ihr) übertragenen Aufgabenbereich stets zu unserer vollsten Zufriedenheit aus.' },
      { note: 2, variant: 1, text: 'Die Leistungen von (Namen) haben jederzeit und in jeder Hinsicht unsere volle Anerkennung gefunden.' },
      { note: 2, variant: 2, text: 'Wir waren mit den Leistungen von (Namen) stets sehr zufrieden.' },
    ],
  },
  {
    field: 'verhalten',
    labelKey: 'certificateCreator.sections.conduct',
    blocks: [
      { note: 1, variant: 1, text: 'Aufgrund (seines/ihres) stets freundlichen und ausgeglichenen Wesens wurde (Name) allseits sehr geschätzt. (Er/Sie) war immer hilfsbereit und zuvorkommend. (Sein/Ihr) Verhalten gegenüber Kundinnen und Kunden, Geschäftsführern, Vorgesetzten, Kolleginnen und Kollegen war ausnahmslos vorbildlich und loyal.' },
      { note: 1, variant: 2, text: 'Aufgrund (seines/ihres) freundlichen und hilfsbereiten Wesens war (er/sie) sowohl bei unseren Geschäftspartnern als auch innerhalb des Unternehmens besonders geschätzt. (Name) strebte stets ein vertrauliches Verhältnis zu unseren Kunden an. (Sein/Ihr) Verhalten gegenüber Kundinnen und Kunden, Geschäftsführern, Vorgesetzten, Kolleginnen und Kollegen war ausnahmslos vorbildlich und loyal.' },
    ],
  },
  {
    field: 'schlussformulierung',
    labelKey: 'certificateCreator.sections.closingStatement',
    blocks: [
      { note: 1, variant: 1, text: 'Das Arbeitsverhältnis (Namen) endet mit Ablauf des {DATUM} auf eigenen Wunsch. Wir bedauern dies sehr, da wir mit (Namen) (einen/eine) sehr (guten/gute) (Mitarbeiter/Mitarbeiterin) verlieren. Für die stets sehr guten Leistungen bedanken wir uns und wünschen (ihm/ihr) für die Zukunft beruflich und privat weiterhin viel Erfolg und alles Gute.' },
      { note: 1, variant: 2, text: '(Name) verlässt unser Unternehmen mit dem {DATUM} auf eigenen Wunsch. Wir bedauern dies sehr, da wir mit (Namen) (einen/eine) sehr (guten/gute) (Mitarbeiter/Mitarbeiterin) verlieren. Wir bedanken uns für die stets sehr guten Leistungen und wünschen (Namen) für die Zukunft privat wie auch beruflich alles Gute.' },
    ],
  },
];

const INTERIM_CERTIFICATE_DE: CertificateCategory[] = [
  {
    field: 'fachwissen',
    labelKey: 'certificateCreator.sections.expertise',
    blocks: [
      { note: 1, variant: 1, text: '(Name) verfügt über ein hervorragendes und auch in Randbereichen sehr tiefgehendes Fachwissen, welches (er/sie) in unser Unternehmen stets in höchst gewinnbringender Weise einbringt.' },
      { note: 1, variant: 2, text: '(Name) verfügt über eine sehr große Berufserfahrung und äußerst umfassende Fachkenntnisse, die (er/sie) immer sehr sicher und gekonnt in der Praxis einsetzt.' },
      { note: 2, variant: 1, text: '(Name) verfügt über umfassende und vielseitige Fachkenntnisse, die (er/sie) immer sicher und gekonnt in der Praxis einsetzt.' },
      { note: 2, variant: 2, text: '(Name) verfügt über ein sehr fundiertes, gutes Fachwissen, welches (er/sie) unserem Unternehmen stets in gewinnbringender Weise zur Verfügung stellt.' },
    ],
  },
  {
    field: 'weiterbildung',
    labelKey: 'certificateCreator.sections.furtherTraining',
    blocks: [
      { note: 1, variant: 1, text: '(Er/Sie) besucht regelmäßig und sehr erfolgreich Weiterbildungsmaßnahmen intern wie auch extern, um (seine/ihre) Stärken weiter auszubauen und (seine/ihre) hervorragenden Fachkenntnisse zu erweitern.' },
      { note: 1, variant: 2, text: '(Er/Sie) nimmt regelmäßig an den unterschiedlichsten, fachbezogenen internen und externen Weiterbildungsmaßnahmen teil und bereichert dadurch immer wieder mit neuen Impulsen die Arbeit in unserem Unternehmen.' },
      { note: 2, variant: 1, text: 'Zum Nutzen unseres Unternehmens erweitert und aktualisiert (er/sie) immer mit gutem Erfolg (seine/ihre) umfassenden Kenntnisse durch regelmäßige Teilnahmen an Weiterbildungsmöglichkeiten.' },
      { note: 2, variant: 2, text: '(Er/Sie) nimmt regelmäßig an den unterschiedlichsten, fachbezogenen internen und externen Weiterbildungsmaßnahmen erfolgreich teil.' },
    ],
  },
  {
    field: 'auffassungsgabe',
    labelKey: 'certificateCreator.sections.comprehension',
    blocks: [
      { note: 1, variant: 1, text: 'Aufgrund (seiner/ihrer) sehr guten Auffassungsgabe ist (er/sie) jederzeit in der Lage, auch schwierige Situationen sofort zutreffend zu erfassen und schnell sehr gute Lösungen zu finden.' },
      { note: 1, variant: 2, text: 'Besonders hervorzuheben sind (seine/ihre) ausgesprochene schnelle Auffassungsgabe und (sein/ihr) analytisches Denkvermögen.' },
      { note: 2, variant: 1, text: 'Aufgrund (seiner/ihrer) genauen Analysefähigkeit und (seiner/ihrer) schnellen Auffassungsgabe ist (er/sie) jederzeit in der Lage, auch schwierige Situationen sofort zutreffend zu erfassen und schnell gute Lösungen zu finden.' },
      { note: 2, variant: 2, text: 'Besonders hervorzuheben sind (sein/ihr) gutes analytisches Denkvermögen und (seine/ihre) rasche Auffassungsgabe.' },
    ],
  },
  {
    field: 'leistungsbereitschaft',
    labelKey: 'certificateCreator.sections.motivation',
    blocks: [
      { note: 1, variant: 1, text: '(Name) zeigt jederzeit hohe Eigeninitiative und identifiziert sich immer voll mit (seinen/ihren) Aufgaben und unserem Unternehmen. (Er/Sie) überzeugt durch (seine/ihre) sehr große Einsatzfreude.' },
      { note: 1, variant: 2, text: '(Name) ist (ein/eine) äußerst (engagierter/engagierte) (Mitarbeiter/Mitarbeiterin), (der/die) besonders durch (seine/ihre) außergewöhnliche Leistungsbereitschaft und außerordentliche Einsatzbereitschaft überzeugt.' },
      { note: 2, variant: 1, text: '(Name) zeigt jederzeit hohe Eigeninitiative und identifiziert sich immer voll mit (seinen/ihren) Aufgaben und unserem Unternehmen. (Er/Sie) überzeugt durch (seine/ihre) große Einsatzfreude.' },
      { note: 2, variant: 2, text: '(Name) ist (ein/eine) (belastbarer/belastbare) und (verantwortungsbewusster/verantwortungsbewusste) (Mitarbeiter/Mitarbeiterin). (Er/Sie) gibt mit großem Einsatz kontinuierliche Impulse zur Verbesserung unserer Dienstleistung.' },
    ],
  },
  {
    field: 'belastbarkeit',
    labelKey: 'certificateCreator.sections.resilience',
    blocks: [
      { note: 1, variant: 1, text: 'Auch in Situationen mit größtem Arbeitsaufkommen erweist (er/sie) sich immer als in höchstem Maße belastbar.' },
      { note: 1, variant: 2, text: 'Auf (seine/ihre) umsichtige und gewissenhafte Arbeitsweise ist auch in herausfordernden Situationen jederzeit Verlass.' },
      { note: 2, variant: 1, text: 'Auch unter schwierigen Arbeitsbedingungen und Termindruck bewältigt (er/sie) alle Aufgaben in guter Weise.' },
      { note: 2, variant: 2, text: 'Auch in Situationen mit hohem Arbeitsaufkommen erweist (er/sie) sich immer als besonders belastbar.' },
    ],
  },
  {
    field: 'arbeitsweise',
    labelKey: 'certificateCreator.sections.workStyle',
    blocks: [
      { note: 1, variant: 1, text: '(Seine/Ihre) Aufgaben führt (er/sie) mit größter Umsicht und hohem Verantwortungsbewusstsein aus. (Er/Sie) ist äußerst belastbar, sehr gewissenhaft und arbeitet stets zügig.' },
      { note: 1, variant: 2, text: '(Name) arbeitet jederzeit sehr zielstrebig, äußerst sorgfältig und mit größter Effizienz. Dabei agiert (er/sie) außerordentlich qualitäts- und verantwortungsbewusst.' },
      { note: 2, variant: 1, text: '(Name) arbeitet sehr zielstrebig, sehr sorgfältig und mit großer Effizienz. Dabei agiert (er/sie) immer qualitäts- und verantwortungsbewusst.' },
      { note: 2, variant: 2, text: '(Seine/Ihre) Arbeitsweise ist sowohl hinsichtlich Kunden- als auch Zielorientierung stets in hohem Maße dienstleistungsorientiert und in jeder Hinsicht sehr gut.' },
    ],
  },
  {
    field: 'zuverlaessigkeit',
    labelKey: 'certificateCreator.sections.reliability',
    blocks: [
      { note: 1, variant: 1, text: '(Name) arbeitet immer außerordentlich zuverlässig und sehr genau.' },
      { note: 1, variant: 2, text: '(Seine/Ihre) Verlässlichkeit und Zuverlässigkeit sind jederzeit vorbildlich.' },
      { note: 2, variant: 1, text: '(Name) arbeitet stets zuverlässig und sehr genau.' },
      { note: 2, variant: 2, text: '(Name) ist in hohem Maße zuverlässig und loyal.' },
    ],
  },
  {
    field: 'arbeitsergebnis',
    labelKey: 'certificateCreator.sections.workResults',
    blocks: [
      { note: 1, variant: 1, text: 'Auch für schwierige Problemstellungen findet (er/sie) sehr effektive Lösungen, die (er/sie) jederzeit erfolgreich in der Praxis umsetzt und damit immer ausgezeichnete Arbeitsergebnisse erzielt.' },
      { note: 1, variant: 2, text: '(Name) überzeugt in besonderem Maße durch die jederzeit sehr gute Qualität (seiner/ihrer) Arbeitsergebnisse.' },
      { note: 2, variant: 1, text: 'Auch bei anspruchsvollen Aufgaben und unter schwierigen Bedingungen erzielt (er/sie) stets gute Ergebnisse.' },
      { note: 2, variant: 2, text: 'Für alle auftretenden Herausforderungen findet (er/sie) ausnahmslos gute Lösungen.' },
    ],
  },
  {
    field: 'zusammenfassendeBeurteilung',
    labelKey: 'certificateCreator.sections.overallAssessment',
    blocks: [
      { note: 1, variant: 1, text: 'Die Leistungen von (Namen) finden jederzeit und in jeder Hinsicht unsere vollste Anerkennung.' },
      { note: 1, variant: 2, text: '(Name) führt den (ihm/ihr) übertragenen Aufgabenbereich stets zu unserer vollsten Zufriedenheit aus.' },
      { note: 2, variant: 1, text: 'Die Leistungen von (Namen) finden jederzeit und in jeder Hinsicht unsere volle Anerkennung.' },
      { note: 2, variant: 2, text: 'Wir sind mit den Leistungen von (Namen) stets sehr zufrieden.' },
    ],
  },
  {
    field: 'verhalten',
    labelKey: 'certificateCreator.sections.conduct',
    blocks: [
      { note: 1, variant: 1, text: 'Aufgrund (seines/ihres) stets freundlichen und ausgeglichenen Wesens wird (Name) allseits sehr geschätzt. (Er/Sie) ist immer hilfsbereit und zuvorkommend. (Sein/Ihr) Verhalten gegenüber Kundinnen und Kunden, Geschäftsführern, Vorgesetzten, Kolleginnen und Kollegen ist ausnahmslos vorbildlich und loyal.' },
      { note: 1, variant: 2, text: 'Aufgrund (seines/ihres) freundlichen und hilfsbereiten Wesens ist (er/sie) sowohl bei unseren Geschäftspartnern als auch innerhalb des Unternehmens besonders geschätzt. (Name) strebt stets ein vertrauliches Verhältnis zu unseren Kunden an. (Sein/Ihr) Verhalten gegenüber Kundinnen und Kunden, Geschäftsführern, Vorgesetzten, Kolleginnen und Kollegen ist ausnahmslos vorbildlich und loyal.' },
    ],
  },
  {
    field: 'schlussformulierung',
    labelKey: 'certificateCreator.sections.closingStatement',
    blocks: [
      { note: 1, variant: 1, text: 'Dieses Zwischenzeugnis wird auf Wunsch von (Namen) erteilt. Diesem Wunsch entsprechen wir gerne. Wir bedanken uns bei (ihm/ihr) für die in der Vergangenheit erbrachten stets sehr guten Leistungen und freuen uns auf eine weiterhin positive Fortsetzung des Arbeitsverhältnisses.' },
      { note: 1, variant: 2, text: '(Name) hat uns um die Erteilung dieses Zwischenzeugnisses gebeten. Diesem Wunsch kommen wir gerne nach, verbunden mit dem Dank für die bisherigen sehr guten Leistungen und der Aussicht auf eine weiterhin positive Fortsetzung des Arbeitsverhältnisses.' },
    ],
  },
];

const WORK_CERTIFICATE_EN: CertificateCategory[] = [
  {
    field: 'fachwissen',
    labelKey: 'certificateCreator.sections.expertise',
    blocks: [
      { note: 1, variant: 1, text: '(Name) possessed outstanding expertise that was also very in-depth in related areas, which (he/she) consistently applied in our company in a highly beneficial manner.' },
      { note: 1, variant: 2, text: '(Name) possessed extensive professional experience and extremely comprehensive expertise, which (he/she) always applied with confidence and skill in practice.' },
      { note: 2, variant: 1, text: '(Name) possessed comprehensive and versatile expertise, which (he/she) always applied with confidence and skill in practice.' },
      { note: 2, variant: 2, text: '(Name) possessed very sound, solid expertise, which (he/she) consistently made available to our company in a profitable manner.' },
    ],
  },
  {
    field: 'weiterbildung',
    labelKey: 'certificateCreator.sections.furtherTraining',
    blocks: [
      { note: 1, variant: 1, text: '(He/She) regularly and successfully participated in both internal and external professional development programs to further build on (his/her) strengths and expand (his/her) outstanding expertise.' },
      { note: 1, variant: 2, text: '(He/She) regularly participated in a wide variety of subject-specific internal and external professional development programs, thereby consistently enriching the work at our company with new ideas.' },
      { note: 2, variant: 1, text: 'To the benefit of our company, (he/she) consistently expanded and updated (his/her) comprehensive knowledge through regular participation in training opportunities, always with great success.' },
      { note: 2, variant: 2, text: '(He/She) successfully participated regularly in a wide variety of subject-specific internal and external training programs.' },
    ],
  },
  {
    field: 'auffassungsgabe',
    labelKey: 'certificateCreator.sections.comprehension',
    blocks: [
      { note: 1, variant: 1, text: 'Thanks to (his/her) excellent comprehension skills, (he/she) was always able to immediately grasp even difficult situations accurately and quickly find very good solutions.' },
      { note: 1, variant: 2, text: 'Particularly noteworthy were (his/her) exceptionally quick comprehension and analytical thinking skills.' },
      { note: 2, variant: 1, text: 'Thanks to (his/her) precise analytical skills and quick grasp of situations, (he/she) was always able to immediately and accurately assess even difficult situations and quickly find good solutions.' },
      { note: 2, variant: 2, text: 'Particularly noteworthy were (his/her) strong analytical thinking skills and quick grasp of situations.' },
    ],
  },
  {
    field: 'leistungsbereitschaft',
    labelKey: 'certificateCreator.sections.motivation',
    blocks: [
      { note: 1, variant: 1, text: '(Name) consistently demonstrated a high degree of initiative and always took full ownership of (his/her) responsibilities and our company. (He/She) impressed with (his/her) exceptional enthusiasm and dedication.' },
      { note: 1, variant: 2, text: '(Name) was an extremely dedicated employee who stood out particularly for (his/her) exceptional willingness to perform and extraordinary commitment.' },
      { note: 2, variant: 1, text: '(Name) consistently demonstrated a high degree of initiative and always identified fully with (his/her) tasks and our company. (He/She) impressed with (his/her) great enthusiasm.' },
      { note: 2, variant: 2, text: '(Name) was a resilient and responsible employee. With great dedication, (he/she) continuously provided ideas for improving our services.' },
    ],
  },
  {
    field: 'belastbarkeit',
    labelKey: 'certificateCreator.sections.resilience',
    blocks: [
      { note: 1, variant: 1, text: 'Even when faced with a heavy workload, (he/she) consistently demonstrated exceptional resilience.' },
      { note: 1, variant: 2, text: '(His/Her) prudent and conscientious approach to work could always be relied upon, even in challenging situations.' },
      { note: 2, variant: 1, text: 'Even under difficult working conditions and tight deadlines, (he/she) handled all tasks effectively.' },
      { note: 2, variant: 2, text: 'Even in situations with a heavy workload, (he/she) always demonstrated exceptional resilience.' },
    ],
  },
  {
    field: 'arbeitsweise',
    labelKey: 'certificateCreator.sections.workStyle',
    blocks: [
      { note: 1, variant: 1, text: '(He/She) carried out (his/her) duties with the utmost care and a strong sense of responsibility. (He/She) was extremely resilient, very conscientious, and always worked efficiently.' },
      { note: 1, variant: 2, text: '(Name) always worked with great determination, extreme care, and the highest efficiency. In doing so, (he/she) demonstrated an exceptional commitment to quality and a strong sense of responsibility.' },
      { note: 2, variant: 1, text: '(Name) worked with great determination, great care, and high efficiency. In doing so, (he/she) always demonstrated a strong commitment to quality and responsibility.' },
      { note: 2, variant: 2, text: '(His/Her) approach to work was consistently highly service-oriented in terms of both customer focus and goal orientation and was excellent in every respect.' },
    ],
  },
  {
    field: 'zuverlaessigkeit',
    labelKey: 'certificateCreator.sections.reliability',
    blocks: [
      { note: 1, variant: 1, text: '(Name) always worked with exceptional reliability and great precision.' },
      { note: 1, variant: 2, text: '(His/Her) dependability and reliability were exemplary at all times.' },
      { note: 2, variant: 1, text: '(Name) always worked reliably and with great precision.' },
      { note: 2, variant: 2, text: '(Name) was highly reliable and loyal.' },
    ],
  },
  {
    field: 'arbeitsergebnis',
    labelKey: 'certificateCreator.sections.workResults',
    blocks: [
      { note: 1, variant: 1, text: 'Even for difficult problems, (he/she) found highly effective solutions, which (he/she) successfully implemented in practice at all times, consistently achieving excellent results.' },
      { note: 1, variant: 2, text: '(Name) was particularly impressive due to the consistently high quality of (his/her) work.' },
      { note: 2, variant: 1, text: 'Even when faced with demanding tasks and under difficult conditions, (he/she) consistently achieved good results.' },
      { note: 2, variant: 2, text: '(He/She) found good solutions to every challenge that arose, without exception.' },
    ],
  },
  {
    field: 'zusammenfassendeBeurteilung',
    labelKey: 'certificateCreator.sections.overallAssessment',
    blocks: [
      { note: 1, variant: 1, text: 'The work of (Name) has always met with our full approval in every respect.' },
      { note: 1, variant: 2, text: '(Name) consistently performed the duties assigned to (him/her) to our complete satisfaction.' },
      { note: 2, variant: 1, text: 'The performance of (Name) has always met with our full approval in every respect.' },
      { note: 2, variant: 2, text: 'We have always been very satisfied with the performance of (Name).' },
    ],
  },
  {
    field: 'verhalten',
    labelKey: 'certificateCreator.sections.conduct',
    blocks: [
      { note: 1, variant: 1, text: 'Thanks to (his/her) consistently friendly and even-tempered nature, (Name) was highly regarded by everyone. (He/She) was always helpful and courteous. (His/Her) conduct toward customers, executives, supervisors, and colleagues was, without exception, exemplary and loyal.' },
      { note: 1, variant: 2, text: 'Due to (his/her) friendly and helpful nature, (he/she) was particularly valued by both our business partners and within the company. (Name) always strove to build a trusting relationship with our customers. (His/Her) conduct toward customers, executives, supervisors, and colleagues was exemplary and loyal without exception.' },
    ],
  },
  {
    field: 'schlussformulierung',
    labelKey: 'certificateCreator.sections.closingStatement',
    blocks: [
      { note: 1, variant: 1, text: 'The employment of (Name) will end on {DATUM} at (his/her) own request. We deeply regret this, as we are losing a very valuable employee in (Name). We thank (him/her) for (his/her) consistently excellent performance and wish (him/her) continued success and all the best in both (his/her) professional and personal life.' },
      { note: 1, variant: 2, text: '(Name) is leaving our company on {DATUM} at (his/her) own request. We deeply regret this, as we are losing a very good employee in (Name). We thank (him/her) for (his/her) consistently excellent performance and wish (Name) all the best for the future, both personally and professionally.' },
    ],
  },
];

const INTERIM_CERTIFICATE_EN: CertificateCategory[] = [
  {
    field: 'fachwissen',
    labelKey: 'certificateCreator.sections.expertise',
    blocks: [
      { note: 1, variant: 1, text: '(Name) possesses outstanding expertise that is also very in-depth in related fields, which (he/she) consistently applies in our company in a highly beneficial manner.' },
      { note: 1, variant: 2, text: '(Name) has extensive professional experience and extremely comprehensive expertise, which (he/she) always applies with confidence and skill in practice.' },
      { note: 2, variant: 1, text: '(Name) has comprehensive and versatile expertise, which (he/she) always applies with confidence and skill in practice.' },
      { note: 2, variant: 2, text: '(Name) possesses very sound, solid expertise, which (he/she) consistently makes available to our company in a beneficial manner.' },
    ],
  },
  {
    field: 'weiterbildung',
    labelKey: 'certificateCreator.sections.furtherTraining',
    blocks: [
      { note: 1, variant: 1, text: '(He/She) regularly and very successfully participates in continuing education programs, both internal and external, to further develop (his/her) strengths and expand (his/her) outstanding expertise.' },
      { note: 1, variant: 2, text: '(He/She) regularly participates in a wide variety of subject-specific internal and external continuing education programs, thereby continually enriching the work in our company with new ideas.' },
      { note: 2, variant: 1, text: 'For the benefit of our company, (he/she) consistently and successfully expands and updates (his/her) comprehensive knowledge through regular participation in continuing education opportunities.' },
      { note: 2, variant: 2, text: '(He/She) successfully participates in a wide variety of subject-specific internal and external continuing education programs on a regular basis.' },
    ],
  },
  {
    field: 'auffassungsgabe',
    labelKey: 'certificateCreator.sections.comprehension',
    blocks: [
      { note: 1, variant: 1, text: 'Thanks to (his/her) excellent comprehension skills, (he/she) is always able to immediately grasp even difficult situations accurately and quickly find very good solutions.' },
      { note: 1, variant: 2, text: 'Particularly noteworthy are (his/her) exceptionally quick comprehension and analytical thinking skills.' },
      { note: 2, variant: 1, text: 'Thanks to (his/her) precise analytical skills and quick comprehension, (he/she) is always able to immediately and accurately grasp even difficult situations and quickly find good solutions.' },
      { note: 2, variant: 2, text: 'Particularly noteworthy are (his/her) strong analytical thinking skills and quick grasp of situations.' },
    ],
  },
  {
    field: 'leistungsbereitschaft',
    labelKey: 'certificateCreator.sections.motivation',
    blocks: [
      { note: 1, variant: 1, text: '(Name) consistently demonstrates a high degree of initiative and is fully committed to (his/her) responsibilities and our company. (He/She) impresses with (his/her) exceptional enthusiasm and dedication.' },
      { note: 1, variant: 2, text: '(Name) is an extremely dedicated employee who impresses particularly with (his/her) exceptional willingness to perform and extraordinary commitment.' },
      { note: 2, variant: 1, text: '(Name) consistently demonstrates a high degree of initiative and is always fully committed to (his/her) tasks and our company. (He/She) impresses with (his/her) great enthusiasm.' },
      { note: 2, variant: 2, text: '(Name) is a resilient and responsible employee. With great dedication, (he/she) continuously provides ideas for improving our services.' },
    ],
  },
  {
    field: 'belastbarkeit',
    labelKey: 'certificateCreator.sections.resilience',
    blocks: [
      { note: 1, variant: 1, text: 'Even when faced with a heavy workload, (he/she) consistently demonstrates exceptional resilience.' },
      { note: 1, variant: 2, text: '(His/Her) prudent and conscientious approach to work can always be relied upon, even in challenging situations.' },
      { note: 2, variant: 1, text: 'Even under difficult working conditions and tight deadlines, (he/she) handles all tasks effectively.' },
      { note: 2, variant: 2, text: 'Even in situations with a heavy workload, (he/she) always demonstrates exceptional resilience.' },
    ],
  },
  {
    field: 'arbeitsweise',
    labelKey: 'certificateCreator.sections.workStyle',
    blocks: [
      { note: 1, variant: 1, text: '(He/She) performs (his/her) duties with the utmost care and a strong sense of responsibility. (He/She) is extremely resilient, very conscientious, and always works efficiently.' },
      { note: 1, variant: 2, text: '(Name) works at all times with great determination, extreme care, and the highest efficiency. In doing so, (he/she) demonstrates an exceptional commitment to quality and responsibility.' },
      { note: 2, variant: 1, text: '(Name) works with great determination, great care, and high efficiency. In doing so, (he/she) always acts with a strong commitment to quality and responsibility.' },
      { note: 2, variant: 2, text: '(His/Her) approach to work is consistently highly service-oriented in terms of both customer focus and goal orientation and is excellent in every respect.' },
    ],
  },
  {
    field: 'zuverlaessigkeit',
    labelKey: 'certificateCreator.sections.reliability',
    blocks: [
      { note: 1, variant: 1, text: '(Name) always works in an exceptionally reliable and highly precise manner.' },
      { note: 1, variant: 2, text: '(His/Her) dependability and reliability are exemplary at all times.' },
      { note: 2, variant: 1, text: '(Name) consistently works in a reliable and precise manner.' },
      { note: 2, variant: 2, text: '(Name) is highly reliable and loyal.' },
    ],
  },
  {
    field: 'arbeitsergebnis',
    labelKey: 'certificateCreator.sections.workResults',
    blocks: [
      { note: 1, variant: 1, text: 'Even for difficult problems, (he/she) finds highly effective solutions, which (he/she) successfully implements in practice at all times, thereby consistently achieving excellent results.' },
      { note: 1, variant: 2, text: '(Name) is particularly impressive due to the consistently high quality of (his/her) work.' },
      { note: 2, variant: 1, text: 'Even when faced with demanding tasks and difficult conditions, (he/she) consistently achieves good results.' },
      { note: 2, variant: 2, text: '(He/She) finds good solutions to every challenge that arises, without exception.' },
    ],
  },
  {
    field: 'zusammenfassendeBeurteilung',
    labelKey: 'certificateCreator.sections.overallAssessment',
    blocks: [
      { note: 1, variant: 1, text: 'We fully acknowledge the performance of (Name) at all times and in every respect.' },
      { note: 1, variant: 2, text: '(Name) consistently performs the duties assigned to (him/her) to our complete satisfaction.' },
      { note: 2, variant: 1, text: 'We fully recognize the performance of (Name) at all times and in every respect.' },
      { note: 2, variant: 2, text: 'We are always very satisfied with the performance of (Name).' },
    ],
  },
  {
    field: 'verhalten',
    labelKey: 'certificateCreator.sections.conduct',
    blocks: [
      { note: 1, variant: 1, text: 'Thanks to (his/her) consistently friendly and even-tempered nature, (Name) is highly regarded by everyone. (He/She) is always helpful and courteous. (His/Her) conduct toward customers, executives, supervisors, and colleagues is, without exception, exemplary and loyal.' },
      { note: 1, variant: 2, text: 'Due to (his/her) friendly and helpful nature, (he/she) is particularly valued by both our business partners and within the company. (Name) always strives to build a trusting relationship with our customers. (His/Her) conduct toward customers, executives, supervisors, and colleagues is exemplary and loyal without exception.' },
    ],
  },
  {
    field: 'schlussformulierung',
    labelKey: 'certificateCreator.sections.closingStatement',
    blocks: [
      { note: 1, variant: 1, text: 'This interim reference is provided at the request of (Name). We are happy to comply with this request. We would like to thank (him/her) for the consistently excellent performance demonstrated in the past and look forward to a continued positive working relationship.' },
      { note: 1, variant: 2, text: '(Name) has asked us to issue this interim reference. We are happy to comply with this request, and we would like to express our gratitude for the excellent performance to date and look forward to a continued positive working relationship.' },
    ],
  },
];

export interface BlockGroup {
  note: 1 | 2;
  blocks: CertificateBlock[];
}

export interface CategoryWithGroups extends CertificateCategory {
  groups: BlockGroup[];
}

export function getCategoriesWithGroups(
  certificateType: string,
  language: string,
): CategoryWithGroups[] {
  const isPast = certificateType !== 'Zwischenzeugnis';
  const isEN = language === 'en';
  let categories: CertificateCategory[];
  if (isPast && isEN) categories = WORK_CERTIFICATE_EN;
  else if (isPast) categories = WORK_CERTIFICATE_DE;
  else if (isEN) categories = INTERIM_CERTIFICATE_EN;
  else categories = INTERIM_CERTIFICATE_DE;

  return categories.map((k) => ({
    ...k,
    groups: ([1, 2] as const).reduce<BlockGroup[]>((acc, note) => {
      const blocks = k.blocks.filter((b) => b.note === note);
      if (blocks.length > 0) acc.push({ note, blocks });
      return acc;
    }, []),
  }));
}
